import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import session from "./session";
import directChannels from "./directChannels";
import server from "./server";
import servers from "./servers";
import channels from "./serverChannels";
import channelComments from "./channelComments";
import discover from "./discover"

const rootReducer = combineReducers({
	session,
	directChannels,
	server,
	servers,
	channels,
	channelComments,
	discover
});

let enhancer;

if (process.env.NODE_ENV === "production") {
	enhancer = applyMiddleware(thunk);
} else {
	const logger = require("redux-logger").default;
	const composeEnhancers =
		window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
	enhancer = composeEnhancers(applyMiddleware(thunk, logger));
}

const configureStore = preloadedState => {
	return createStore(rootReducer, preloadedState, enhancer);
};

export default configureStore;
